"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
const clientform_1 = require("models/clientform");
const stdGridForm_1 = require("views/stdGridForm");
const boutons_1 = require("../outils/boutons");
const tools_1 = require("../outils/tools");
const rechercheCodePostal_1 = require("./rechercheCodePostal");
class Clients extends stdGridForm_1.default {
    constructor(app, name) {
        let conf = { moduleName: "clients" };
        super(app, name, conf);
    }
    config() {
        let firstFocusField = "codeClientField";
        let masque = {
            rows: [
                { cols: [
                        { template: (0, globals_1._)("Fiche client"), css: "webix_header app_header", height: 32,
                            width: 250, "borderless": true },
                        { view: "menu", "borderless": true,
                            id: "stdGridFormMenu",
                            data: [boutons_1.creerButton, boutons_1.modifierButton, boutons_1.supprimerButton, boutons_1.enregistrerButton, boutons_1.annulerButton]
                        }
                    ] },
                { body: clientform_1.clientsform, "borderless": false },
                { template: "", fillspace: true, height: 1 }
            ]
        };
        let grid = {
            view: "datatable", id: "tableClientsId",
            css: "webix_header_border webix_data_border",
            resizeColumn: true, dragColumn: true, sort: "multi",
            onContext: {},
            columns: clientform_1.clientsColumns,
            select: true,
            url: globals_1.phpPath + "clients.php?option=list",
            updateFromResponse: true,
            undo: true,
            save: {
                updateFromResponse: true,
                "insert": globals_1.phpPath + "clients.php?option=insert",
                "update": globals_1.phpPath + "clients.php?option=update",
                "delete": globals_1.phpPath + "clients.php?option=delete"
            },
            on: {
                onBlur: function (view) {
                    let vv = "state" + view.config.id;
                    webix.storage.local.put(vv, this.getState());
                },
                onResize: function (width) {
                    if (userResize == 0) {
                        userResize = 1; // le premier resize n'est pas du fait de l'utilisateur
                    }
                    else {
                        globals_1.lv2.userPrefs.dirty = true;
                        globals_1.lv2.userPrefs.clientformwidth = width;
                    }
                }
            }
        };
        let userResize = 0;
        let gridToolbar = {
            view: "toolbar", "borderless": true, "height": 38,
            elementsConfig: {
                maxWidth: 120, "borderless": true,
            },
            elements: [
                { template: (0, globals_1._)("Liste des clients"), css: "webix_header app_header", height: 42, width: 200 },
                { view: "search", placeholder: (0, globals_1._)("Recherche par nom ..."), id: "search", width: 200,
                    attributes: { lv2: "gridSearchField" } },
                { view: "icon", icon: "mdi mdi-reload", tooltip: (0, globals_1._)("Actualiser"),
                    click: () => this.reload() },
                { view: "icon", icon: "mdi mdi-table-arrow-down", id: "imprimerTableButtonId", value: "",
                    tooltip: (0, globals_1._)("Générer pdf depuis la liste"),
                    click: () => (0, tools_1.imprimerTable)("tableClientsId", (0, globals_1._)("Liste clients"))
                },
                // imprimerTableButton("tableClientsId", _("Liste clients")),   ne marche pas, je ne sais pas pourquoi
                (0, boutons_1.preferencesAffichage)("tableClientsId", clientform_1.clientsColumns),
                (0, boutons_1.supprimerPreferences)("tableClientsId", "clientformwidth")
            ]
        };
        let liste = { id: "clientsGrid", rows: [gridToolbar, grid] };
        return {
            cols: [liste, { view: "resizer" }, masque, { view: "resizer" }, { template: "" }]
        };
    }
    notEmptyEmail(value) {
        if (value != "") {
            // @ts-ignore
            return webix.rules.isEmail(value);
        }
        return true;
    }
    init() {
        let me = this;
        this.currentForm = $$("clientFormId");
        this.currentGrid = $$("tableClientsId");
        this.leftPane = $$("clientsGrid");
        this.backend = "clients.php";
        // Maintenant j'applique les personnalisations.
        // Je charge les personnalisations
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "parametres.php?key=clients.form&option=readjson");
        promise.then(function (result) {
            me.tune(result.json());
        });
        let menu = this.$$("stdGridFormMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "creerButton":
                    me.creer();
                    break;
                case "modifierButton":
                    me.modifier();
                    break;
                case "supprimerButton":
                    me.supprimerFiche();
                    break;
                case "enregistrerButton":
                    me.enregistrer();
                    break;
                case "annulerButton":
                    me.annuler();
                    break;
            }
        });
        // initialisation du menu contextuel
        let menuData = [];
        if ((globals_1.lv2.droits).includes("clients.call"))
            menuData.push({ "id": 1, value: (0, globals_1._)("Appeler mobile") });
        if ((globals_1.lv2.droits).includes("clients.call"))
            menuData.push({ "id": 2, value: (0, globals_1._)("Appeler fixe") });
        if ((globals_1.lv2.droits).includes("clients.email"))
            menuData.push({ "id": 3, value: (0, globals_1._)("Courriel") });
        if (menuData.length > 0)
            menuData.push({ $template: "Separator" });
        if ((globals_1.lv2.droits).includes("facturation.save")) {
            menuData.push({ "id": 4, value: (0, globals_1._)("Facture"), route: "#!/pgiLayout/factures?client=" });
        }
        webix.ui({
            view: "contextmenu",
            data: menuData,
            master: $$("tableClientsId"),
            on: {
                onItemClick: function (id) {
                    let context = this.getContext();
                    let dtable = context.obj;
                    let idRow = context.id;
                    let client = dtable.getItem(idRow);
                    // webix.message(this.getItem(id).id);
                    let vv = this.getItem(id).id;
                    let rt = this.getItem(id).route;
                    if (vv == 1) {
                        window.open("tel:" + client.mobile);
                    }
                    if (vv == 2) {
                        window.open("tel:" + client.telephone);
                    }
                    if (vv == 3) {
                        window.open("mailto:" + client.email);
                    }
                    if (vv == 4) {
                        window.location.href = rt + client.unid;
                    }
                }
            }
        });
        this.lastAction = "";
        let dp = webix.dp(this.currentGrid);
        dp.attachEvent("onAfterSave", function (response, id) {
            let record = me.currentGrid.getItem(id);
            if (!record.unid) {
                record.unid = response.unid;
            }
            // @ts-ignore
            me.currentGrid.select(id);
            me.currentGrid.showItem(id);
        });
        // ça ne marche pas, l'erreur de suppression est gérée dans onAfterSaveError
        // l'enregistrement n'est pas supprimé, mais l'utilisateur n'est pas prévenu
        // dp.attachEvent("onAfterDelete", function(response,id,details){
        // 	let msg = response.message;
        // 	if (response.success == false)
        // 		me.currentGrid.undo(id);
        // 		webix.alert({ text : msg });
        // });
        dp.attachEvent("onAfterSaveError", function (id, status, response, details) {
            let msg = response.message;
            if (status == "delete") {
                dp.blockEvent();
                me.currentGrid.undo(id);
                webix.alert({ text: msg });
                dp.unblockEvent();
                return;
            }
            else {
                webix.alert({ text: msg }).then(() => {
                    var values = me.currentForm.getValues();
                    if (values.unid > 0) {
                        me.lastAction = "update";
                        // me.lockRecord(values.unid);  en cas d'erreur il reste verrouillé
                    }
                    else {
                        me.lastAction = "abortCreate";
                        me.currentGrid.undo();
                    }
                    me.setEditMode(true);
                    $$("deconnexionButton").disable();
                    me.currentForm.focus($$(me.firstFocusField));
                });
            }
        });
        this.currentForm.bind(this.currentGrid);
        this.use(webix_jet_1.plugins.UnloadGuard, () => {
            if (me.currentForm.isDirty()) {
                return me.exit();
            }
            if (me.locked) {
                me.deVerrou();
            }
        });
        if (globals_1.lv2.userPrefs) {
            if ("clientformwidth" in globals_1.lv2.userPrefs) {
                // webix.message(lv2.userPrefs["clientformwidth"].toString());
                this.currentGrid.define("width", globals_1.lv2.userPrefs["clientformwidth"]);
                this.currentGrid.resize();
            }
        }
        // fonction de recherche
        // fonction de recherche article
        let searchField = $$("search");
        searchField.attachEvent("onTimedKeyPress", function () {
            let value = this.getValue().toLowerCase();
            me.currentGrid.filter(function (obj) {
                // J'attends encore qu'on m'explique pourquoi je dois faire le toString ici et pas sur les articles
                // parce qu'ici il y a des noms qui sont assimilés à des nombres
                let oNom = obj.adresseNom.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                return oNom.toLowerCase().indexOf(value) != -1;
            });
        });
        let form = this.currentForm;
        // Création de la recherche code postal
        if (!this.rechercheCodePostal) {
            // @ts-ignore
            this.rechercheCodePostal = this.ui(rechercheCodePostal_1.default);
        }
    }
    ready() {
        super.ready();
        let me = this;
        let clientPro = this.$$("comptePro");
        // @ts-ignore
        clientPro.attachEvent("onChange", function (newValue) {
            let siret = me.$$("siret");
            let numTVA = me.$$("numTVA");
            let adresseNom = me.$$("adresseNom");
            let nomClient = me.$$("nomClient");
            let prenomClient = me.$$("prenomClient");
            if (newValue == 1) {
                siret.show();
                numTVA.show();
                adresseNom.show();
                nomClient.hide();
                prenomClient.hide();
            }
            else {
                siret.hide();
                numTVA.hide();
                adresseNom.show();
                nomClient.hide();
                prenomClient.hide();
            }
        });
        // recherche de code postal
        let cpField = this.$$("adresseCPField");
        let villeField = this.$$("adresseVilleField");
        cpField.attachEvent("onKeyPress", function (code, e) {
            let cc = this;
            let keyCode = code;
            // déclenchement de la recherche CP uniquement sur Entrée
            if (code == 13 && !e.ctrlKey && !e.shiftKey && !e.altKey) {
                let code = cpField.getValue();
                me.rechercheCodePostal.showPopup(cpField.$view, code);
                return false;
            }
        });
        // retour de la fenêtre de recherche de code postal
        this.app.attachEvent("code:postal:choisi", function (item) {
            globals_1.lv2.trace(item.cp + "#" + item.ville);
            // Obligé d'ajouter le timeout, sinon let id=.. provoque une erreur
            // Ceci est apparu avec la V10.0.1, me.currentgrid n'est pas défini tant que la fenêtre de recherche n'est pas refermée
            setTimeout(function () {
                cpField.setValue(item.cp);
                villeField.setValue(item.vi);
            }, 20);
        });
        //
        this.setEditMode(false);
    }
}
exports.default = Clients;
